// Örnek servis codiagno login
import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "/admin";

export default {

  /**
   * Creates an admin.
   * @param {{ Username: string, Name: string, Surname: string, Password: string }} body 
   * @returns {Promise}
   */
  createAdmin(body) {
    return axios.post(`${RESOURCE_NAME}/create-admin`, body);
  },

  /**
   * Get admin list.
   * @param {{ Username: string, Name: string, Surname: string, Page: number, PageSize: number }} params 
   * @returns {Promise}
   */
   getList(params) {
    return axios.get(`${RESOURCE_NAME}/list`, { params });
  },

  /**
   * Update an admin account.
   * @param {{ Username: string, Name: string, Surname: string, Password: string, Id: number }} body 
   * @returns {Promise}
   */
  update(body) {
    return axios.put(`${RESOURCE_NAME}/update`, body);
  },

  /**
   * Delete an admin account.
   * @param {number} id 
   * @returns {Promise}
   */
   delete(id) {
    return axios.delete(`${RESOURCE_NAME}/delete/${id}`);
  },

  /**
   * Get details of an admin account.
   * @param {number} id 
   * @returns {Promise}
   */
  getDetails(id) {
    return axios.get(`${RESOURCE_NAME}/get-details?Id=${id}`);
  },
  
};
